import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceFilter = ({ activeFilter, onFilterChange, activeIndustry, onIndustryChange }) => {
  const categories = [
    { id: 'all', label: 'All Services', icon: 'Grid3x3' },
    { id: 'it', label: 'IT Solutions', icon: 'Server' },
    { id: 'branding', label: 'Branding', icon: 'Palette' },
    { id: 'security', label: 'Security', icon: 'Shield' },
    { id: 'cloud', label: 'Cloud', icon: 'Cloud' }
  ];

  const industries = [
    { id: 'all', label: 'All Industries' },
    { id: 'healthcare', label: 'Healthcare' },
    { id: 'saas', label: 'SaaS' },
    { id: 'enterprise', label: 'Enterprise' },
    { id: 'startup', label: 'Startup' }
  ];

  return (
    <div className="bg-card rounded-xl shadow-md p-4 md:p-6 mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1">
          <label className="text-sm font-semibold text-foreground mb-3 block">Filter by Service Type</label>
          <div className="flex flex-wrap gap-2">
            {categories?.map((category) => (
              <button
                key={category?.id}
                onClick={() => onFilterChange(category?.id)}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 flex items-center gap-2 ${
                  activeFilter === category?.id
                    ? 'bg-gradient-to-b from-[#2642B2] to-[#1a365d]  text-primary-foreground shadow-md'
                    : 'bg-muted text-text-secondary hover:bg-gradient-to-b from-[#2642B2] to-[#1a365d] '
                }`}
              >
                <Icon name={category?.icon} size={16} />
                {category?.label}
              </button>
            ))}
          </div>
        </div>
        
        {/* <div className="lg:w-64">
          <label className="text-sm font-semibold text-foreground mb-3 block">Filter by Industry</label>
          <select
            value={activeIndustry}
            onChange={(e) => onIndustryChange(e?.target?.value)}
            className="w-full px-4 py-2 rounded-lg border border-border bg-input text-foreground focus:outline-none focus:ring-2 focus:ring-ring text-sm"
          >
            {industries?.map((industry) => (
              <option key={industry?.id} value={industry?.id}>
                {industry?.label}
              </option>
            ))}
          </select>
        </div> */}
      </div>
    </div>
  );
};

export default ServiceFilter;